import { OfferCardWide } from '@sravni/creditselection-react/lib/OfferCard';
import { Avatar } from '@sravni/react-design-system';
import cn from 'classnames';
import React, { type ReactElement } from 'react';

import type { TVitrinsOffersCardProps } from 'shared/ui/VitrinsOffersCard';

import { OtherOffers } from './OtherOffers/OtherOffers';
import styles from './VitrinsOffersCard.module.scss';

export const VitrinsOffersCard: FC<TVitrinsOffersCardProps> = ({
  otherOffers = [],
  title,
  subtitle,
  summary,
  img,
  controls,
  children,
  isGrayCard,
  type,
  className,
}) => {
  const countOffers = otherOffers.length;
  const isShowAdditionalInfo = !!countOffers && Boolean(children);

  return (
    <OfferCardWide
      withControlsMobileBorder={false}
      cardClassName={cn(styles.card, { [styles.grayCard]: !!isGrayCard }, className)}
      title={title}
      subtitle={subtitle}
      icon={
        img ? (
          <Avatar
            src={img}
            className={styles.logo}
          />
        ) : (
          (null as unknown as ReactElement)
        )
      }
      summary={summary}
      badges={null}
      controls={controls}
      additionalInfo={
        isShowAdditionalInfo ? (
          <OtherOffers
            countOffers={countOffers}
            offersType={type}
          >
            {children}
          </OtherOffers>
        ) : null
      }
    />
  );
};
